// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-element[data-v-5e87bcc9]{height:auto !important}\n", ""]);
// Exports
module.exports = exports;
